
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_brdst_vxsbn_145",
  "loading": "awsui_loading_brdst_vxsbn_149",
  "undo-button": "awsui_undo-button_brdst_vxsbn_153"
};
  